"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.QuotationApi = void 0;
var env_1 = require("../../env");
var utils_1 = require("../../core/websdk/utils");
var _authCode = env_1.Env.WebSdkToken;
var property = env_1.Env.WebSdkHotelId;
var api = {
    get: function (params) { return env_1.Env.WebSdkBaseUrl + "/quotation?" + utils_1.serialize(__assign({ _authCode: _authCode, property: property }, params)); }
};
exports.QuotationApi = api;
//# sourceMappingURL=websdk-quotation.api.js.map